import { useEffect } from "react";
import { Box, Chip, Typography, Divider } from "@mui/joy";
import { Clock, PackageCheck } from "lucide-react";
import moment from "moment";

import TaskActionComponent from "../../../components/Tasks/components/TaskAction";
import { PermitPhotos } from "./PermitPhotos";
import { Button } from "../../../shared";

interface ITaskComponent {
    activeTask: any;
    onComplete: any;
    actionProgress: any;
}

export default function BuildingPermitTaskComponent(props: ITaskComponent) {
    const { activeTask, onComplete, actionProgress } = props;
    const { CreatedAt, Status } = activeTask;

    useEffect(() => {
        const scrollableDiv = document.getElementById("project-details-parent");
        if (scrollableDiv) {
            //scrollableDiv.scrollTop = 0; // or use scrollTo
            scrollableDiv.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, []);

    return (
        <Box>
            <Box mt={2} ml={1} mr={1}>
                <Typography startDecorator={<PackageCheck size={16} />} level="body-sm" gutterBottom>
                    Task
                </Typography>
                <Typography level="h4" sx={{ fontWeight: 500 }}>
                    Building Permit
                </Typography>

                <Box mt={2} display={"flex"} gap={1}>
                    <Chip
                        color={Status === "COMPLETED" ? "success" : "warning"}
                        sx={{ fontSize: 12, border: "1px solid", borderColor: "divider" }}
                    >
                        {Status}
                    </Chip>
                    <Chip color="neutral" variant="outlined" sx={{ fontSize: 12 }} startDecorator={<Clock size={14} />}>
                        Created On: {moment(CreatedAt).format("MM/DD/YYYY")}
                    </Chip>
                </Box>

                <Box mt={3}>
                    <Box flex={1}>
                        <Typography level={"body-sm"} sx={{ color: "text.primary", fontWeight: 600 }} gutterBottom>
                            Description
                        </Typography>
                        <Typography level={"body-md"} sx={{ color: "text.primary" }}>
                            The primary goal of the Building Permit stage is to secure the necessary regulatory
                            approvals required for project execution. This stage involves preparing and submitting
                            permit applications, coordinating with local authorities, and ensuring compliance with
                            building codes and regulations. By proactively managing the permitting process, it helps
                            prevent legal or scheduling delays and ensures that construction activities can begin
                            smoothly once approvals are granted.
                        </Typography>
                    </Box>
                </Box>

                <Box mt={2}>
                    <Box>
                        <Box mt={1} mb={2}>
                            <Button>Download as Zip</Button>
                        </Box>
                        <Typography level={"body-sm"} sx={{ color: "text.primary", fontWeight: 600 }} gutterBottom>
                            Manage photos
                        </Typography>
                        <Divider sx={{ mt: 1, mb: 2 }} />
                        <Box display={"flex"} flexDirection={"column"} gap={2}>
                            <PermitPhotos taskDetails={activeTask} />
                        </Box>
                    </Box>
                </Box>

                <TaskActionComponent
                    taskName={"Material Ordering"}
                    onComplete={onComplete}
                    actionProgress={actionProgress}
                    isNextEligible={true}
                />
            </Box>
        </Box>
    );
}
